import React from 'react';
import styled from 'styled-components';
import { SlideImage } from '../ProceedTopUp.style';
import { Slide } from "react-slideshow-image";

const Container = styled.div`
   padding: 24px 0;

   .react-slideshow-container {
    border-radius: 16px;
    border: 1px solid #FFD648;

    img {
        border-radius: 16px;
    }
   }

   .indicators {
    padding-inline-start: 0 !important;
    margin-top: 16px !important;

    .each-slideshow-indicator:before {
        background: #AA5E1B !important;
    }
   }
`;

const Title = styled.div`
padding: 8px 12px;
	margin-bottom: 16px;
	background: linear-gradient(90deg, rgba(255, 214, 71, 0.00) 0%, #FFD647 50%, rgba(255, 214, 71, 0.00) 100%);
	backdrop-filter: blur(25px);

	font-size: 16px;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
	color: #2A2A2A;
	text-align: center;
`;

const SampleSlide = ({
    active_topup_screenshot,
    receiving_account,
}) => {

    return (
        <Container>
            <Title>How to Top-up?</Title>
            {((!active_topup_screenshot && receiving_account?.payment_category_view_sample_images?.length > 0) ||
                (active_topup_screenshot && receiving_account?.payment_category_view_topup_images?.length > 0))
                && (
                    <Slide
                        arrows={false}
                        autoplay={true}
                        indicators={true}
                        duration={3000}
                        transitionDuration={500}
                    >
                        {active_topup_screenshot
                            ? receiving_account?.payment_category_view_topup_images?.map(
                                (image, key) => (
                                    <SlideImage key={key} src={image} />
                                )
                            )
                            : receiving_account?.payment_category_view_sample_images?.map(
                                (image, key) => (
                                    <SlideImage key={key} src={image} />
                                )
                            )}
                    </Slide>
                )}
        </Container>
    )
}

export default SampleSlide